import {
   ChakraSVGCircle,
   ChakraSVGGroup,
   ChakraSVGText,
   ChakraSVGCircleProps,
   ChakraSVGGroupProps,
   ChakraSVGTextProps,
} from './styleableSvgComponents';

export function BasicCluster({
   scaledX,
   scaledY,
   text,
   innerCircleProps,
   outerCircleProps,
   textProps,
   groupProps,
}: {
   scaledX: number;
   scaledY: number;
   text: string;
   innerCircleProps?: ChakraSVGCircleProps;
   outerCircleProps?: ChakraSVGCircleProps;
   textProps?: ChakraSVGTextProps;
   groupProps?: ChakraSVGGroupProps;
}) {
   return (
      <ChakraSVGGroup {...groupProps}>
         <ChakraSVGCircle x={scaledX} y={scaledY} r={24} {...outerCircleProps} />
         <ChakraSVGCircle x={scaledX} y={scaledY} r={20} {...innerCircleProps} />
         <ChakraSVGText x={scaledX} y={scaledY} textAnchor="middle" {...textProps}>
            {text}
         </ChakraSVGText>
      </ChakraSVGGroup>
   );
}
